import translations from './translations'
import { GLOBAL_ERROR_DEFAULT } from './../models/ErrorCode'

translations.add('is', {
    errors: {
        [GLOBAL_ERROR_DEFAULT]: 'Eitthvað fór úrskeiðis!'
    }
})
